// Telegram WebApp utilities

export function showNotification(message: string, type: 'success' | 'error' | 'warning' = 'success') {
  const telegram = window.Telegram?.WebApp

  if (telegram?.showAlert) {
    telegram.showAlert(message)
  }

  // Also provide haptic feedback
  if (telegram?.HapticFeedback) {
    switch (type) {
      case 'success':
        telegram.HapticFeedback.notificationOccurred('success')
        break
      case 'error':
        telegram.HapticFeedback.notificationOccurred('error')
        break
      case 'warning':
        telegram.HapticFeedback.notificationOccurred('warning')
        break
    }
  }
}

export function impactOccurred(style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft' = 'light') {
  const telegram = window.Telegram?.WebApp
  if (telegram?.HapticFeedback) {
    telegram.HapticFeedback.impactOccurred(style)
  }
}

export function selectionChanged() {
  const telegram = window.Telegram?.WebApp
  if (telegram?.HapticFeedback) {
    telegram.HapticFeedback.selectionChanged()
  }
}